import { useEffect } from 'react';
import { useTranslation } from 'next-i18next';

import { measureProductDetailsView } from '@utils/analytics';
import { getPathUrl, getRouteUrl } from '@utils/urls';

import { PRODUCT } from '@common/routes.mjs';

const useProductStructuredData = ({
  productId,
  productColorVariation,
  sizeId,
  title,
}) => {
  const {
    i18n: { language },
    t,
  } = useTranslation('common');

  const {
    productColorId,
    availability,
    colorTitle = '',
    images = [],
    price = 0,
    publishedUntil,
    specialPrice = 0,
    sortingPrice,
    slug,
  } = productColorVariation;

  const articleNr = `${productColorId}-${sizeId}`;

  useEffect(() => {
    const product = {
      color_id: productColorId,
      id: sizeId ? articleNr : productColorId,
      name: title,
      price: specialPrice || price,
      productId,
      size: sizeId,
      variant: colorTitle,
      specialPrice,
      quantity: 1,
      ordinaryPrice: price,
    };

    measureProductDetailsView(product);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articleNr]);

  return {
    availability,
    brand: t('seo.productStructuredData.brand', 'Chicorée'),
    images,
    name: `${title} ${colorTitle}`,
    price: sortingPrice,
    priceCurrency: 'CHF',
    priceValidUntil: publishedUntil,
    sku: productColorId,
    url: getPathUrl(
      getRouteUrl(language, PRODUCT, {
        id: sizeId ? articleNr : productColorId,
        slug,
      }),
    ),
  };
};

export default useProductStructuredData;
